import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { UsersPopover } from 'APP/components/UsersPopover/UsersPopover';

import {
  IMessageViewsPopoverProps,
  useMessageViewsPopoverPresenter,
} from './MessageViewsPopover.presenter';

export const MessageViewsPopover: FC<IMessageViewsPopoverProps> = observer((props) => {
  const presenter = useMessageViewsPopoverPresenter(props);

  if (!presenter.isOpened) {
    return null;
  }

  return (
    <UsersPopover
      isOpened={presenter.isOpened}
      data={presenter.users}
      moreCount={presenter.moreCount}
      onClick={presenter.onMoreClick}
    />
  );
});
